import React, { useState, useEffect } from "react";
import { ReptoolModal } from "../../utilities/ReptoolModal.tsx";
import { BasicFetch } from "../../../utils/BasicFetch.ts";
import { ReptileTile, ReptileTilePlaceholder } from "../../utilities/ReptileTile.tsx";
import { CollectionReptile } from "../../collection/types/CollectionTypes.ts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { AddPickModal } from "../../collection/modals/AddPickModal.tsx";
import { Gene } from "../../../types/Gene.ts";
import { Morph } from "../../../types/Morph.ts";
import { useRepToolContext } from "../../../RepToolContext.tsx";

const AddTile = ({
  onSelect
}: {
  onSelect: () => void;
}) => {
  return (
    <div onClick={onSelect} className={`col-6 col-md-4 text-center reptile-tile-container`}>
      <div className={`reptile-tile h-100 p-2 d-flex flex-column justify-content-between`} style={{
        cursor: 'pointer',
        border: '1px dashed',
        boxShadow: 'initial',
      }}>
        <div className="my-auto text-light">
          <FontAwesomeIcon icon={faPlus} className="fa-3x" />
          <h5 className="text-light mt-4">Add Animal</h5>
        </div>
      </div>
    </div>
  )
}

export const SelectCollectionReptileModal = ({
  closeModal,
  onSelect,
  sexFilter,
  allReptiles = false,
  genes,
  morphs,
  onCollectionAdd
}: {
  closeModal: () => void;
  onSelect: (reptile: CollectionReptile) => void;
  sexFilter?: "male" | "female";
  allReptiles?: boolean;
  genes: Gene[];
  morphs: Morph[];
  onCollectionAdd?: () => void;
}) => {
  const [fetchingData, setFetchingData] = useState<boolean>(true);
  const [reptiles, setReptiles] = useState<CollectionReptile[]>([]);
  const [showAddModal, setShowAddModal] = useState<boolean>(false);
  const [reptileSelected, setReptileSelected] = useState<boolean>(false);
  const {appendControls} = useRepToolContext();
  const extra = allReptiles ? {} : { reptile: localStorage.getItem('selectedReptile') };

  const fetchData = () => {
    BasicFetch({
      url: `${(window as any).serverLocation}collection_reptile/get_all`,
      extra,
      onSuccess: (data) => {
        setReptiles(data.reptiles.filter(reptile => sexFilter ? reptile.gender === sexFilter : true));
      },
      onFinish: () => {
        setFetchingData(false);
      }
    })
  }

  useEffect(() => {
    fetchData();
    if (!showAddModal) {
      appendControls(null, 'Select Collection Reptile Modal');
    }

  }, [showAddModal]);
  const numberOfItems = [1, 2, 3, 4, 5, 6, 7, 8];
  return (
    <>
      {showAddModal && <AddPickModal
        closeModal={() => setShowAddModal(false)}
        genes={genes}
        morphs={morphs}
        isSpecies={false}
        status={"available"}
        allReptiles={allReptiles}
        lockStatus
        updateGroups={() => {
          fetchData();
          setShowAddModal(false);
          onCollectionAdd?.();
        }}
      />}

      <ReptoolModal id='select-collection-reptile-modal' title={`Select ${sexFilter || 'an animal'}`} closeModal={closeModal} body={
        <div className="d-flex flex-column">
          <div className="d-flex flex-row flex-wrap justify-content-around">
            {fetchingData && numberOfItems.map(item => (
              <ReptileTilePlaceholder hideButton={false} />
            ))}
            {!fetchingData && <AddTile onSelect={() => setShowAddModal(true)} />}
            {reptiles.map(reptile => (
              <ReptileTile key={reptile.id}
                clickEvent={(collectionReptile) => {
                  setReptileSelected(true);
                  onSelect(collectionReptile);
                }}
                reptile={reptile}
                morphInfo={undefined}
                buttonText="Select"
                working={reptileSelected}
              />
            ))}
          </div>
        </div>
      } />
    </>
  )
}
